if (!customElements.get('product-add-to-cart-sticky')) {
class ProductAddToCartSticky extends HTMLElement {
    constructor() {
        super();
        this.handleScroll = this.handleScroll.bind(this);
        this.handleVariantChange = this.handleVariantChange.bind(this);
        this.handleNavigationEvent = this.handleNavigationEvent.bind(this);
        this.observeNavigation = this.observeNavigation.bind(this);
        this.sectionId = this.dataset.section;
    }

    connectedCallback() {
        this.targetElement = document.getElementById('ProductSubmitButton-' + this.sectionId);
        this.footerElement = document.querySelector('footer');
        this.stickyAtcVariantInput = this.querySelector('.product-variant-id');

        window.addEventListener("scroll", this.handleScroll, { passive: true });
        window.addEventListener("resize", this.handleScroll);
        this.navigationObserver = new MutationObserver(() => this.scheduleNavigationUpdate());
        this.observeNavigation();
        ['pointerover', 'pointerout', 'focusin', 'focusout', 'toggle'].forEach((type) => {
            document.addEventListener(type, this.handleNavigationEvent, true);
        });
        document.addEventListener('shopify:section:load', this.observeNavigation);
        this.handleScroll();
        this.updateCompactDisplay();
        this.compactObserver = new MutationObserver(() => this.updateCompactDisplay());
        this.compactObserver.observe(this, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'data-preorder'] });
        document.body.addEventListener('change', this.handleVariantChange);
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
                if (event.data.sectionId !== this.sectionId) return;
                const source = event.data.html.querySelector('product-add-to-cart-sticky[data-section="' + this.sectionId + '"]');
                if (!source) return;
                this.querySelectorAll('.selected-variant-option').forEach((option) => {
                    const updated = Array.from(source.querySelectorAll('.selected-variant-option'))
                        .find((candidate) => candidate.dataset.optionName === option.dataset.optionName);
                    if (updated) option.textContent = updated.textContent;
                });
                this.updateCompactDisplay();
            });
        }
    }

    disconnectedCallback() {
        this.compactObserver?.disconnect();
        this.unsubscribeVariant?.();
        this.navigationObserver?.disconnect();
        cancelAnimationFrame(this.navigationFrame);
        this.navigationFrame = null;
        ['pointerover', 'pointerout', 'focusin', 'focusout', 'toggle'].forEach((type) => {
            document.removeEventListener(type, this.handleNavigationEvent, true);
        });
        document.removeEventListener('shopify:section:load', this.observeNavigation);
        window.removeEventListener("scroll", this.handleScroll);
        window.removeEventListener("resize", this.handleScroll);
        document.body.removeEventListener('change', this.handleVariantChange);
    }

    updateCompactDisplay() {
        this.querySelectorAll('.selected-variant-option').forEach(option => {
            let value = option.textContent.trim().split(':').slice(1).join(':').trim();
            if (!value) return;
            const isoSize = value.match(/^(A[0-6])(?:\s|$)/i);
            option.dataset.compact = isoSize ? isoSize[1].toUpperCase() : value.split(' / ')[0].trim();
        });
        this.querySelectorAll('.price-item').forEach(price => {
            const value = price.textContent.trim();
            if (!value) return;
            price.dataset.compactPrice = this.dataset.currency === 'EUR' ? value.replace(/\s*EUR\b/g, '').trim() : value;
        });
        const button = this.querySelector('.sticky-atc-button');
        const label = button?.querySelector(':scope > span');
        if (!label) return;
        if (!button.disabled && !button.hasAttribute('data-preorder') && label.textContent.trim() === this.dataset.fullAdd) {
            label.dataset.compactLabel = this.dataset.shortAdd;
        } else {
            delete label.dataset.compactLabel;
        }
    }

    getAbsoluteTop(element) {
        let top = 0;
        while (element) {
            top += element.offsetTop || 0;
            element = element.offsetParent;
        }
        return top;
    }

    observeNavigation() {
        this.navigationObserver.disconnect();
        document.querySelectorAll('.section-header, sticky-header, header.header, #drawer-search, [data-drawer="header_menu_drawer"], cart-drawer').forEach((element) => {
            this.navigationObserver.observe(element, {
                attributes: true,
                subtree: true,
                childList: true,
                attributeFilter: ['open', 'class', 'inert', 'aria-expanded']
            });
        });
        this.scheduleNavigationUpdate();
    }

    handleNavigationEvent(event) {
        const selector = 'header, .section-header, #drawer-search, [data-drawer="header_menu_drawer"], cart-drawer';
        if (event.target?.closest?.(selector) || event.relatedTarget?.closest?.(selector)) {
            this.scheduleNavigationUpdate();
        }
    }

    scheduleNavigationUpdate() {
        if (this.navigationFrame) return;
        this.navigationFrame = requestAnimationFrame(() => {
            this.navigationFrame = null;
            if (this.isConnected) this.handleScroll();
        });
    }

    isNavigationOpen() {
        return Boolean(document.querySelector(
            'header .list-menu__has-mega:hover, header .list-menu__has-mega:focus-within, ' +
            'header .list-menu__has-dropdown:hover, header .list-menu__has-dropdown:focus-within, ' +
            'header .header__inline-menu details[open], ' +
            '[data-drawer="header_menu_drawer"][open], [data-drawer="header_menu_drawer"].active, ' +
            '#drawer-search[open], cart-drawer.active'
        ));
    }

    handleScroll() {
        this.targetElement = document.getElementById('ProductSubmitButton-' + this.sectionId);
        const navigationOpen = this.isNavigationOpen();
        this.classList.toggle('navigation-hidden', navigationOpen);
        if (!this.targetElement) {
            this.classList.remove('show');
            return;
        }
        const header = document.querySelector('sticky-header');
        const headerSection = header?.closest('.shopify-section');
        const candidates = [header, headerSection, ...document.querySelectorAll('.wallify-sticky-promo, .wallify-promo-bar, .wallify-discount-bar')].filter(Boolean);
        let headerBottom = 0;
        candidates.forEach((element) => {
            const rect = element.getBoundingClientRect();
            if (rect.top <= 1 && rect.bottom > 0) headerBottom = Math.max(headerBottom, rect.bottom);
        });
        this.style.setProperty('--wallify-sticky-top', headerBottom + 'px');
        const target = this.targetElement.getBoundingClientRect();
        const footer = this.footerElement?.getBoundingClientRect();
        const shouldShow = !navigationOpen && target.bottom < headerBottom && (!footer || footer.top > window.innerHeight);
        this.classList.toggle('show', shouldShow);
    }

    updateStickyATCOption(optionName, optionValue) {
        const matches = optionName.match(/options\[(.+)\]/);
        if (matches && matches[1]) {
            optionName = matches[1];
        }

        const optionDisplay = this.querySelector('.selected-variant-option[data-option-name="' + optionName + '"]');
        if (optionDisplay) {
            const labels = JSON.parse(optionDisplay.dataset.valueLabels || '{}');
            optionDisplay.textContent = (optionDisplay.dataset.optionLabel || optionName) + ': ' + (labels[optionValue] || optionValue);
        }
    }

    handleVariantChange(event) {
        const target = event.target;
        const productSection = target.closest(`#MainProduct-${this.sectionId}`);
        if (!productSection) return;
        if (target.tagName === 'INPUT' || target.tagName === 'SELECT') {
            const optionName = target.name;
            const optionValue = target.value;
            this.updateStickyATCOption(optionName, optionValue);
        }
    }
}

if (!customElements.get('product-add-to-cart-sticky')) customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}
